import type { Article, Url as UrlType } from "../../types/content";

import { getPulseTracker } from "..";

const trackUrlResourceClick = (
  resource: UrlType,
  article: Article | undefined,
  urlIndex: number | undefined,
) => {
  const pulseTracker = getPulseTracker();

  let isSponsored = false;
  let sponsorName = undefined;

  if (resource.sponsored) {
    isSponsored = true;
    sponsorName = resource.source;
  }

  if (article?.sponsor) {
    isSponsored = true;
    sponsorName = article.sponsor;
  }

  pulseTracker?.executePulseCommand("track", "engagementEvent", {
    action: "Click",
    object: {
      type: "RedirectUrl",
      url: resource.url,
      "spt:custom": {
        article_id: article?.article_id || "",
        article_title: article?.title.value || "",
        index: urlIndex || 0,
        is_sponsored: isSponsored,
        omni_key: resource.omni_key || false,
        paywall: resource.paywall || false,
        source: resource.source,
        ...(isSponsored ? { sponsor: sponsorName } : undefined),
      },
    },
  });
};

export { trackUrlResourceClick };
